import './ResultInfo.scss';

import React from 'react';

import Loader from '../../../../../../common/Loader';
import bem from '../../../../../../utils/bem';
import ErrorsSection from '../../ErrorsSection/ErrorsSection/ErrorsSection';
import { useDownloadCustomPacingReport } from '../../hooks/useDownloadCustomPacingReport';
import type { ErrorItem } from '../../types';
import { getLineItemsAmountText } from './utils';

export type ResultInfoProps = {
  countSuccessItems: number;
  errorItems: ErrorItem[];
  reportId: string | null;
};

export const CUSTOM_PACING_SAVE_SUCCESS_TITLE = 'Custom pacing schedule successful';
export const CUSTOM_PACING_SAVE_FAIL_TITLE = 'Custom pacing schedule failed';

const [block, element] = bem('result-info');

const ResultInfo = ({ countSuccessItems, errorItems, reportId }: ResultInfoProps): React.JSX.Element => {
  const { loading, downloadReport } = useDownloadCustomPacingReport(reportId ?? '', '');

  const isSaveSuccessful = countSuccessItems > 0;

  return (
    <div className={block()} data-testid="resultInfoContainer">
      <p className={element('title')}>
        {isSaveSuccessful ? CUSTOM_PACING_SAVE_SUCCESS_TITLE : CUSTOM_PACING_SAVE_FAIL_TITLE}
      </p>
      {isSaveSuccessful && (
        <div className={element('block-content')}>
          <div className={element('block-text-wrapper')}>
            <div className={`${element('block-text')} ${element('success-block-text')}`}>
              A Custom Pacing Schedule was created successfully for {getLineItemsAmountText(countSuccessItems)}.
            </div>

            {reportId &&
              (loading ? (
                <div className={element('view-report-loading')}>
                  <Loader />
                </div>
              ) : (
                <button onClick={downloadReport} className={`${element('block-text')} ${element('view-report')}`}>
                  View Report
                </button>
              ))}
          </div>
        </div>
      )}
      {errorItems.length ? (
        <>
          <div className={element('divider')}></div>
          <ErrorsSection errorItems={errorItems} />
        </>
      ) : null}
    </div>
  );
};

export default ResultInfo;
